export default {
  star: 'お気に入り',
  playAgain: {
    name: '再生設定',
    radioTitle: '再生可能',
    inputTitle: '再生回数',
    options: ['いいえ', 'はい'],
    unit: '回',
    unlimited: '無制限',
  },
  autoEndTime: {
    name: '操作制限時間',
    radioTitle: '操作時間の制限',
    inputTitle: '操作時間',
    options: ['制限なし', '制限あり'],
  },
  global_click: {
    name: 'グローバルリダイレクト',
    desc: 'プレイヤーはフルスクリーン内で、どこをクリックしてもストアのダウンロードページにジャンプします',
  },
  auto_click: {
    name: '自動リダイレクト',
    desc: '何も操作しない場合は自動的にストアのダウンロードページにジャンプします',
  },
  yd_click: {
    name: 'クリックを誘導',
    desc: 'ユーザーが特定の操作を行った後、自動的にストアのダウンロードページにジャンプします',
  },
  colorConfig: {
    name: '色の設定',
  },
  difficulty: {
    configured: '設定済み',
    configure: '設定に移動',
    easy: {
      name: '簡単な難易度',
    },
    medium: {
      name: '中程度の難易度',
    },
    hard: {
      name: '難しい難易度',
    },
  },
  stars: {
    name: 'お気に入り',
  },
  level: {
    name: 'レベル設定',
  },
  score: {
    name: 'スコア設定',
  },
  jump: {
    name: 'ジャンプ設定',
  },
  time: {
    name: 'タイム設定',
  },
  rate: {
    name: '頻度設定',
  },
  range: {
    name: '判定範囲設定',
  },
  prob: {
    name: '確率設定',
  },
}
